import {
  Modal,
  ModalClose,
  ModalPrimaryActionButton,
  ModalTertiaryActionButton,
} from '@la/ds-ui-components';
import styles from './RemoveFromCartModal.module.scss';

export type RemoveFromCartModalProps = {
  open: boolean;
  closeModal: () => void;
  // loading: boolean;
  removeCartItem: () => void;
};

/* RemoveFromCartModal */
export default function RemoveFromCartModal({
  open,
  closeModal,
  // loading,
  removeCartItem,
}: RemoveFromCartModalProps) {
  return (
    <Modal
      open={open}
      onOpenChange={closeModal}
      title="Remove item"
      hideClose={false}
      size="small"
      primaryAction={
        <ModalPrimaryActionButton
          onClick={removeCartItem} /* loading={loading} */
        >
          Yes, remove this
        </ModalPrimaryActionButton>
      }
      tertiaryAction={
        <ModalClose>
          <ModalTertiaryActionButton>Cancel</ModalTertiaryActionButton>
        </ModalClose>
      }
    >
      <div className={styles.modalContent}>
        You are now removing this item from your cart, all registration progress
        will be lost.
        <div className={styles.confirmSentence}>
          Are you sure you want to continue?
        </div>
      </div>
    </Modal>
  );
}
/* */
